export const PHASE_NEW = 'new';
export const PHASE_INITIAL_REVIEW = 'initial_review';
export const PHASE_PLAGIARISM_CHECK = 'plagiarism_check';
export const PHASE_DESK_REVIEW = 'desk_review';
export const PHASE_PEER_REVIEW = 'peer_review';
export const PHASE_PEER_REVIEW_HANDLE = 'peer_review_handle';
export const PHASE_DECISION_MAKING = 'decision_making';
export const PHASE_AUTHOR_DECISION = 'author_decision';
export const PHASE_PUBLISHED = 'published';

export const PHASES_LIST = [
    PHASE_NEW,
    PHASE_INITIAL_REVIEW,
    PHASE_PLAGIARISM_CHECK,
    PHASE_DESK_REVIEW,
    PHASE_PEER_REVIEW,
    PHASE_DECISION_MAKING,
    PHASE_AUTHOR_DECISION,
    PHASE_PUBLISHED
];



// WEBPACK FOOTER //
// ./src/constants/phases.js